/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  DrmSummaryTableDto,
  ErrorResponse,
  ValidationErrorResponse,
} from '../models/index';
import {
    DrmSummaryTableDtoFromJSON,
    DrmSummaryTableDtoToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    ValidationErrorResponseFromJSON,
    ValidationErrorResponseToJSON,
} from '../models/index';

export interface GetDrmSummaryTableForDrmRequest {
    drmId: string;
}

export interface GetDrmSummaryTableForSectionRequest {
    sectionId: string;
}

/**
 * 
 */
export class DrmSummaryControllerApi extends runtime.BaseAPI {

    /**
     */
    async getDrmSummaryTableForDrmRaw(requestParameters: GetDrmSummaryTableForDrmRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<DrmSummaryTableDto>>> {
        if (requestParameters['drmId'] == null) {
            throw new runtime.RequiredError(
                'drmId',
                'Required parameter "drmId" was null or undefined when calling getDrmSummaryTableForDrm().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/monitoring/drm/{drmId}/summary-table`.replace(`{${"drmId"}}`, encodeURIComponent(String(requestParameters['drmId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DrmSummaryTableDtoFromJSON));
    }

    /**
     */
    async getDrmSummaryTableForDrm(requestParameters: GetDrmSummaryTableForDrmRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<DrmSummaryTableDto>> {
        const response = await this.getDrmSummaryTableForDrmRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDrmSummaryTableForSectionRaw(requestParameters: GetDrmSummaryTableForSectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DrmSummaryTableDto>> {
        if (requestParameters['sectionId'] == null) {
            throw new runtime.RequiredError(
                'sectionId',
                'Required parameter "sectionId" was null or undefined when calling getDrmSummaryTableForSection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/monitoring/drm/{drmId}/summary-table/{sectionId}`.replace(`{${"sectionId"}}`, encodeURIComponent(String(requestParameters['sectionId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DrmSummaryTableDtoFromJSON(jsonValue));
    }

    /**
     */
    async getDrmSummaryTableForSection(requestParameters: GetDrmSummaryTableForSectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DrmSummaryTableDto> {
        const response = await this.getDrmSummaryTableForSectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
